<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/electronics/ADC2/ADC2.jpg" alt="200-1-01">
            </div>
            <div class="detail-banner-r">
                
                <div class="detail-banner-t2">ADC2.0 驾驶域控制器</div>
                <div class="detail-banner-desc">基于地平线J6M自动驾驶计算平台。</div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">产品说明</div>

                    <div class="detail-desc">
                        <div>
                            基于地平线J6M自动驾驶计算平台
                        </div>
                        <div>
                            行泊一体域控制器，支持L2级辅助驾驶
                        </div>
                        <div>
                            3路毫米波雷达，11路高清摄像头，12路超声波雷达，1路激光雷达
                        </div>
                        <div>
                            厘米级高精度定位
                        </div>
                        <div>
                            水冷设计
                        </div>
                        <div>
                            功能安全 ASIL B
                        </div>
                        <div>
                            驾驶功能：高速NOA, 智慧巡航，泊车辅助
                        </div>
                    </div>
                </div>

                <div class="one-titile">
                    核心配置
                </div>
                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/ADC2/ADC2-1.jpg" alt="200-1-02">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                产品参数
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">9～16V</div>
                                    <div class="k">工作电压范围</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">13.5V</div>
                                    <div class="k">工作电压</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">≤0.4mA</div>
                                    <div class="k">静态电流</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">18GB+64GB</div>
                                    <div class="k">存储</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">128 TOPS</div>
                                    <div class="k">算力</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
    title: 'ADC2.0驾驶域控制器 - 蜂巢汽车官网',
    keywords: '蜂巢,蜂巢汽车,发动机,变速器,电子',
    description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
    outputPath: 'electronics/ADC2.html'
};

import { createApp } from 'vue';
import App from './ADC2.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./ADC2.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
